import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
function getSecondsUntilMidnightMadrid(): number {
  const now = new Date();
  const madridString = now.toLocaleString('en-US', {
    timeZone: 'Europe/Madrid'
  });
  const madridNow = new Date(madridString);
  const midnight = new Date(madridNow);
  midnight.setHours(24, 0, 0, 0);
  return Math.max(0, Math.floor((midnight.getTime() - madridNow.getTime()) / 1000));
}
export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState(getSecondsUntilMidnightMadrid());
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getSecondsUntilMidnightMadrid());
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return timeLeft;
}
export function formatCountdown(seconds: number) {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
interface CountdownTimerProps {
  delay?: number;
  className?: string;
}
export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  delay = 0,
  className = ''
}) => {
  const timeLeft = useCountdown();
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.4,
    delay
  }} className={`flex items-center justify-center gap-2 text-brand-crimson font-semibold text-base md:text-lg ${className}`} data-id="element-74">
      <span className="w-3 h-3 rounded-full bg-brand-crimson animate-pulse" data-id="element-75"></span>
      <span data-id="element-76">Oferta expira en:</span>
      <span className="font-bold tracking-wider bg-brand-crimson/10 px-3 py-1 rounded-md" data-id="element-77">
        {formatCountdown(timeLeft)}
      </span>
    </motion.div>;
};